import { ManagerPayPeriodApprovalsCard } from "@/components/ManagerPayPeriodApprovalsCard";
import { useAdminViewModel } from "@/pages/dashboard/admin/AdminViewModelContext";

export function PayPeriodReviewsView() {
  const {
    user,
    queryClient,
    isAdmin,
    isManagerOnly,
    isReadonlyAdmin,
    isDualManagerReadonly,
    canViewReports,
    canEditPunches,
    managedEditUserIds,
    filterCostCode,
    setFilterCostCode,
    filterCustomer,
    setFilterCustomer,
    filterEmployee,
    setFilterEmployee,
    filterCostCodeSearch,
    setFilterCostCodeSearch,
    filterCostCodeOpen,
    setFilterCostCodeOpen,
    filterCostCodeRef,
    filterCustomerSearch,
    setFilterCustomerSearch,
    filterCustomerOpen,
    setFilterCustomerOpen,
    filterCustomerRef,
    filterEmployeeSearch,
    setFilterEmployeeSearch,
    filterEmployeeOpen,
    setFilterEmployeeOpen,
    filterEmployeeRef,
    fromDate,
    setFromDate,
    toDate,
    setToDate,
    entriesSearch,
    setEntriesSearch,
    entriesPage,
    setEntriesPage,
    entriesPageSize,
    setEntriesPageSize,
    exportError,
    setExportError,
    filterCostCodesData,
    filterCustomersData,
    filterEmployeesData,
    entriesLoading,
    entriesCountData,
    correctionStats,
    correctionStatsLoading,
    filteredEntries,
    chartData,
    handleExport,
  } = useAdminViewModel();

  return (
    <div className="mt-4 grid grid-cols-1 gap-4 [&>*]:min-w-0">
                {/* Manager/admin queue: employee pay-period submissions awaiting review */}
                <ManagerPayPeriodApprovalsCard
                  enabled={canViewReports}
                  canReview={isAdmin || isManagerOnly}
                />
    </div>
  );
}
